import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000', ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M10.17 1.477a.75.75 0 01.75.75v2.25a.75.75 0 01-1.5 0v-2.25a.75.75 0 01.75-.75zM10.17 18.727a.75.75 0 01.75.75v2.25a.75.75 0 01-1.5 0v-2.25a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M5.114 5.045a4.5 4.5 0 013.182-1.318h3.375a4.5 4.5 0 014.5 4.5.75.75 0 01-1.5 0 3 3 0 00-3-3H8.296a3 3 0 100 6h4.125a4.5 4.5 0 012.636.853.75.75 0 01-.879 1.216 3.003 3.003 0 00-1.757-.57H8.296a4.5 4.5 0 01-3.182-7.681zm-.943 9.932a.75.75 0 01.75.75 3 3 0 003 3h2.25a.75.75 0 110 1.5H7.92a4.5 4.5 0 01-4.5-4.5.75.75 0 01.75-.75zM20.537 14.823a.75.75 0 01.75.75v1.97a.75.75 0 01-.75.75h-1.969a.75.75 0 010-1.5h1.219v-1.22a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M16.591 15.844a2.854 2.854 0 00-2.02.838.75.75 0 01-1.062-1.06 4.353 4.353 0 016.164 0l1.394 1.39a.75.75 0 11-1.06 1.062l-1.394-1.39-.001-.002a2.854 2.854 0 00-2.02-.838zM11.896 19.864a.75.75 0 01.75-.75h1.968a.75.75 0 010 1.5h-1.219v1.218a.75.75 0 01-1.5 0v-1.968z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M12.114 19.334a.75.75 0 011.061-.001l1.395 1.39v.001a2.856 2.856 0 004.042 0 .75.75 0 111.061 1.06 4.356 4.356 0 01-6.163 0l-1.394-1.39a.75.75 0 01-.002-1.06z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
